// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qr-code[data-v-3d7cb850]{\n  max-width:200px;\n  max-height:200px;\n  margin:0 auto\n}\n.bg-gradient[data-v-3d7cb850]{\n  background:linear-gradient(-45deg,#869de4,#4a2695,#4a2695,#869de4);\n  color:#fff\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
